import { Component, input, ViewEncapsulation } from '@angular/core';

import { generateId } from '@lc/util';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { provideValidator, provideValueAccessor, TextInputControlValueAccessor } from '../util';

@Component({
  selector: 'bspk-text-input',
  imports: [NgxMaskDirective],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss',
  providers: [
    provideValueAccessor(BspkTextInput),
    provideValidator(BspkTextInput),
    provideNgxMask(),
  ],
  host: {
    'data-bspk': 'text-input',
    '[attr.data-size]': 'size()',
    '[attr.data-invalid]': 'invalid() || null',
    '[attr.data-disabled]': 'disabled() || disabledState() || null',
    '[attr.data-readonly]': 'readOnly() || null',
  },
  encapsulation: ViewEncapsulation.None,
})
export class BspkTextInput extends TextInputControlValueAccessor {
  readonly controlId = input(generateId('text-input'));
}
